var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-container",
        [
          _c(
            "v-row",
            _vm._l(_vm.photoCards, function (card, index) {
              return _c(
                "v-col",
                {
                  key: card.src,
                  attrs: { cols: "12", md: "6", lg: "4", xl: "3" },
                },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "soli-round",
                      staticStyle: { border: "none" },
                      attrs: { ripple: false, disabled: card.disabled },
                      on: {
                        click: function ($event) {
                          _vm.expand == index
                            ? (_vm.expand = null)
                            : [
                                (_vm.expand = index),
                                _vm.getApiEvents(card, index),
                                _vm.getApiGiftCards(card, index),
                                _vm.getApiSummerCamps(card, index),
                              ]
                        },
                      },
                    },
                    [
                      _c("v-img", {
                        attrs: {
                          src: card.src,
                          "lazy-src": card.lazy,
                          height: "400",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        [
                          _c(
                            "div",
                            { staticStyle: { height: "100px" } },
                            [
                              _c("v-card-title", [_vm._v(_vm._s(card.title))]),
                              _vm._v(" "),
                              _c("v-card-subtitle", [
                                _vm._v(_vm._s(card.subtitle)),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            { staticClass: "ma-3", attrs: { icon: "" } },
                            [
                              _c("v-icon", [
                                _vm._v(
                                  _vm._s(
                                    _vm.expand == index
                                      ? "expand_less"
                                      : "expand_more"
                                  )
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-expand-transition",
                        { staticClass: "soli-round" },
                        [
                          _vm.expand == index
                            ? _c(
                                "v-card",
                                {
                                  staticClass:
                                    "transition-fast-in-fast-out v-card--reveal soli-round",
                                  staticStyle: {
                                    height: "100%",
                                    border: "none",
                                  },
                                },
                                [
                                  _c("v-card-title", [
                                    _vm._v(_vm._s(card.title)),
                                  ]),
                                  _vm._v(" "),
                                  _c("v-card-subtitle", [
                                    _vm._v(_vm._s(card.subtitle)),
                                  ]),
                                  _vm._v(" "),
                                  card.nearMe && _vm.$page.props.auth.user
                                    ? _c(
                                        "v-btn",
                                        {
                                          class: ["ma-3"],
                                          staticStyle: {
                                            position: "absolute",
                                            top: "0px",
                                            right: "0px",
                                          },
                                          attrs: { plain: "", ripple: false },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              ;[
                                                (_vm.nearMe = !_vm.nearMe),
                                                _vm.getApiEvents(card, index),
                                              ]
                                            },
                                          },
                                        },
                                        [
                                          _c("small", { staticClass: "mr-2" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.nearMe ? "Near Me" : "All"
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                color: _vm.nearMe
                                                  ? "secondary"
                                                  : null,
                                              },
                                            },
                                            [_vm._v("near_me")]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !card.events
                                    ? _c("v-container", { staticClass: "px-6" })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.eventsLoading
                                    ? _c("v-skeleton-loader", {
                                        staticClass: "mx-auto",
                                        attrs: {
                                          "max-width": "300",
                                          type: "list-item, list-item, list-item",
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  card.events &&
                                  !card.timeline &&
                                  !card.registration
                                    ? _c(
                                        "v-container",
                                        {
                                          staticClass: "pt-0",
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-form",
                                            {
                                              ref: "giftCardForm",
                                              refInFor: true,
                                              on: {
                                                submit: function ($event) {
                                                  $event.preventDefault()
                                                  return _vm.purchaseGiftCard.apply(
                                                    null,
                                                    arguments
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "v-list",
                                                [
                                                  _c(
                                                    "v-btn-toggle",
                                                    {
                                                      staticClass:
                                                        "w-full mb-3",
                                                      attrs: {
                                                        mandatory: "",
                                                        dense: "",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.giftCardForm
                                                            .price,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.giftCardForm,
                                                            "price",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "giftCardForm.price",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-col",
                                                        {
                                                          staticClass:
                                                            "pa-0 ma-0",
                                                          attrs: { cols: "12" },
                                                        },
                                                        _vm._l(
                                                          card.events,
                                                          function (event) {
                                                            return _c(
                                                              "v-list-item",
                                                              {
                                                                key: event.amount,
                                                              },
                                                              [
                                                                _c("SoliBtn", {
                                                                  staticClass:
                                                                    "mb-3",
                                                                  attrs: {
                                                                    block: "",
                                                                    text: _vm.formatUnitAmount(
                                                                      event.amount
                                                                    ),
                                                                    value:
                                                                      event,
                                                                    color:
                                                                      "soli-grey",
                                                                    outlined:
                                                                      "",
                                                                  },
                                                                }),
                                                              ],
                                                              1
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.$page.props.auth.user
                                                    ? _c("SoliText", {
                                                        staticClass:
                                                          "px-3 mb-3",
                                                        attrs: {
                                                          errors:
                                                            _vm.errors.email,
                                                          rules:
                                                            _vm.rules.email,
                                                          hideDetails: "",
                                                          icon: "alternate_email",
                                                          label: "Your email",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.giftCardForm
                                                              .email,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.giftCardForm,
                                                              "email",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "giftCardForm.email",
                                                        },
                                                      })
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "px-3" },
                                                [
                                                  _c("SoliBtn", {
                                                    attrs: {
                                                      gradient:
                                                        "gradient-orange",
                                                      type: "submit",
                                                      text: "Buy Now",
                                                      block: "",
                                                      loading:
                                                        _vm.giftCardFormLoading,
                                                      disabled: _vm.$page.props
                                                        .auth.user
                                                        ? !_vm.giftCardForm
                                                            .email
                                                        : false,
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "small",
                                                {
                                                  staticClass:
                                                    "flex justify-center soli-grey mt-1 px-4",
                                                },
                                                [
                                                  _vm._v(
                                                    "Printable certificate, good for\n                                        services at any Musicologie\n                                        location."
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  card.events && card.timeline
                                    ? _c(
                                        "v-timeline",
                                        {
                                          staticStyle: {
                                            height: "358px",
                                            "overflow-y": "auto",
                                          },
                                          attrs: { "align-top": "", dense: "" },
                                        },
                                        [
                                          !card.events.length &&
                                          !_vm.eventsLoading
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "flex justify-center",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                    No events found\n                                "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm._l(card.events, function (event) {
                                            return _c(
                                              "v-timeline-item",
                                              {
                                                key: event.id,
                                                attrs: { "fill-dot": "" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "icon",
                                                      fn: function () {
                                                        return [
                                                          _c(
                                                            "small",
                                                            {
                                                              staticClass:
                                                                "white--text",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  event.weekday ||
                                                                    _vm
                                                                      .formatUnitAmount(
                                                                        event.price
                                                                      )
                                                                      .split(
                                                                        "."
                                                                      )[0]
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                      proxy: true,
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              },
                                              [
                                                _vm._v(" "),
                                                _c(
                                                  "v-row",
                                                  {
                                                    staticClass:
                                                      "mb-5 mr-1 pt-1.5 pl-2",
                                                  },
                                                  [
                                                    _c(
                                                      "v-card",
                                                      {
                                                        staticClass:
                                                          "row soli-round",
                                                        attrs: { outlined: "" },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            card.action
                                                              ? card.action(
                                                                  event
                                                                )
                                                              : _vm.$emit(
                                                                  "selectClass",
                                                                  event
                                                                )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        !event.wide
                                                          ? _c(
                                                              "v-col",
                                                              {
                                                                staticStyle: {
                                                                  display:
                                                                    "grid",
                                                                },
                                                                attrs: {
                                                                  cols: "3",
                                                                },
                                                              },
                                                              [
                                                                _c("strong", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      `${event.start}`
                                                                    )
                                                                  ),
                                                                ]),
                                                                _vm._v(" "),
                                                                _c("small", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      event.date
                                                                    )
                                                                  ),
                                                                ]),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticStyle: {
                                                              display: "grid",
                                                            },
                                                          },
                                                          [
                                                            _c("strong", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  event.description
                                                                )
                                                              ),
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("small", [
                                                              _vm._v(
                                                                "\n                                                    " +
                                                                  _vm._s(
                                                                    event
                                                                      .location
                                                                      .name
                                                                  ) +
                                                                  "\n                                                "
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          }),
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  card.events &&
                                  !card.timeline &&
                                  card.registration
                                    ? _c(
                                        "v-container",
                                        {
                                          staticClass: "pt-0",
                                          staticStyle: {
                                            height: "358px",
                                            "overflow-y": "auto",
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                            },
                                          },
                                        },
                                        _vm._l(card.events, function (event) {
                                          return _c(
                                            "v-card",
                                            {
                                              key: event.id,
                                              staticClass:
                                                "soli-round pa-4 mb-3",
                                              attrs: {
                                                href: card.register,
                                                outlined: "",
                                              },
                                            },
                                            [
                                              _c(
                                                "strong",
                                                { staticClass: "flex" },
                                                [_vm._v(_vm._s(event.title))]
                                              ),
                                              _c("small", [
                                                _vm._v(
                                                  _vm._s(event.description)
                                                ),
                                              ]),
                                              _c(
                                                "v-card-actions",
                                                { staticClass: "justify-end" },
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        rounded: "",
                                                        color: "primary",
                                                        href: event.register,
                                                      },
                                                    },
                                                    [_vm._v("Register")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        }),
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  card.learn
                                    ? _c(
                                        "v-card-actions",
                                        {
                                          staticClass:
                                            "pa-3 justify-end w-full white",
                                          staticStyle: {
                                            position: "absolute",
                                            bottom: "0px",
                                            right: "0px",
                                            "z-index": "3",
                                          },
                                        },
                                        [
                                          card.learn
                                            ? _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    text: "",
                                                    plain: "",
                                                    href: `https://musicologielessons.com/${card.learn}`,
                                                    target: "_blank",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                    Learn More\n                                "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          card.getStarted
                                            ? _c(
                                                "v-btn",
                                                {
                                                  staticClass:
                                                    "gradient-orange white--text soli-round",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.$emit(
                                                        "createLesson",
                                                        true
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Get Started")]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }